<template>
  <div class="kpt-list-pagination">
    <div class="kpt-page-selector">
      <span>Page</span>
      <b-select size="is-small" @input="goToPage" v-model="targetPage">
        <option v-for="(opt, idx) in pageNumbers" :value="opt" :key="idx">{{opt}}</option>
      </b-select>
      <span>of {{pageCount}}</span>
    </div>
    <div class="kpt-prev-next">
      <b-button size="is-small" icon-left="chevron-left" :disabled="!hasPrevious" @click="goPrevious">Previous</b-button>
      <b-button size="is-small" icon-right="chevron-right" :disabled="!hasNext" @click="goNext">Next</b-button>
    </div>
    <div class="kpt-showing-label">
      <p>Showing {{((current-1) * size + 1)}} to {{(current * size) > total ? total : current * size }} of {{total}}</p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      targetPage: null
    };
  },
  name: 'ListPagination',
  mounted() {
    this.targetPage = this.current;
  },
  props: {
    total: [Number, String],
    current: {
      type: [Number, String],
      default: 1
    },
    size: {
      type: [Number, String],
      default: 25
    }
  },
  computed: {
    /**
     * Total page size (count).
     */
    pageCount() {
      return Math.ceil(this.total / this.size);
    },
    hasPrevious() {
      return this.current > 1;
    },
    hasNext() {
      return this.current < this.pageCount;
    },
    pageNumbers() {
      const pages = [];
      for (let i = 1; i <= this.pageCount; i++) {
        pages.push(i);
      }
      return pages;
    }
  },
  methods: {
    goPrevious() {
      if (!this.hasPrevious) return;
      this.$emit('change', this.current - 1);
      this.targetPage = this.current - 1;
      // this.$emit('update:current', this.current - 1);
    },
    goNext() {
      if (!this.hasNext) return;
      this.$emit('change', this.current + 1);
      this.targetPage = this.current + 1;
      // this.$emit('update:current', this.current + 1);
    },
    goToPage() {
      this.$emit('change', this.targetPage);
    }
  }
};
</script>
<style lang="scss" scoped>
.kpt-list-pagination {
  display: flex;
  align-items: center;

  .kpt-page-selector {
    display: flex;
    align-items:center;
    div.control {
      padding: 0 5px;
    }
  }

  .kpt-prev-next {
    display: flex;
    margin: 0 12px;
  }

  .kpt-showing-label {

  }
}

.ky-jump-to {
  padding-left: 10px;
  input {
    width: 40px;
    margin-left: 5px;
  }
}

.ky-page-size {
  padding-left: 10px;
  .select {
    padding-left: 5px;
  }
}
</style>
